export default "__VITE_ASSET__DF376hPN__"